import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tooltip } from '@bufferapp/ui';
import { Add } from '@bufferapp/ui/Icon';
import { actions as composerPopoverActions } from '~/composer-popover';
import { SEGMENT_NAMES } from '~/constants';
import { AddUpdateButton, ButtonWrapper } from './style';
import createCalendarPostContext from '../hooks/createCalendarPostContext';

const AddButton = ({
  labelDate,
  fullWidth,
  onAddPostClick,
  defaultTimeslot,
}) => {
  const { selectedProfileIds } = useContext(createCalendarPostContext);

  const openComposer = () => {
    const composerData = {
      selectedProfileIds,
      cta: SEGMENT_NAMES.CALENDAR_CREATE_A_POST,
      shouldResetComposerData: true,
    };
    if (defaultTimeslot) {
      composerData.post = {
        scheduled_at: defaultTimeslot,
        scheduledAt: defaultTimeslot,
        due_at: defaultTimeslot,
      };
      composerData.hasDefaultTime = true;
    }
    onAddPostClick(composerData);
  };

  const AddButtonContent = (
    <Tooltip label="Add a post" position="top">
      <AddUpdateButton
        tabIndex="-1"
        data-testid="button-element"
        type="secondary"
        fullWidth={fullWidth}
        icon={<Add />}
        hasIconOnly
        onClick={openComposer}
        label={`Schedule new post for ${labelDate}`}
      />
    </Tooltip>
  );

  if (!fullWidth) {
    return <ButtonWrapper>{AddButtonContent}</ButtonWrapper>;
  }
  return AddButtonContent;
};

AddButton.propTypes = {
  labelDate: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  defaultTimeslot: PropTypes.number,
};

AddButton.defaultProps = {
  fullWidth: false,
  defaultTimeslot: null,
};

export default connect(null, (dispatch) => ({
  onAddPostClick: (composerData) => {
    dispatch(composerPopoverActions.handleCreatePostClick(composerData));
  },
}))(AddButton);
